import React from 'react';
import { useAtom } from 'jotai';
import { NUMBER_OF_SWATCHES_TO_SHOW } from 'commons/constants';
import useMobileColumnCount from 'components/consumer/ProductListingPage/state/mobileColumnCount/useMobileColumnCount';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import { createSearchProductClickHandler } from 'components/consumer/consumer-search/algolia-insights-helpers/createSearchProductClickHandler';
import lastInsightsClickAtom from 'components/consumer/consumer-search/advanced-search/atoms/lastInsightsClickAtom';

const AdvancedSearchProductsGrid = ({ products }) => {
  const mobileColumnCount = useMobileColumnCount();
  const [, setLastInsightsClick] = useAtom(lastInsightsClickAtom);
  return (
    <div className="md:space-y-8 md:mb-8 md:flex-1 min-h-[400px]">
      <ProductCardGridUI
        limitWidth={false}
        columnsOnDesktop="auto"
        columnsOnMobile={mobileColumnCount}
      >
        {!!products &&
          products?.length > 0 &&
          products?.map(
            (
              {
                campaign,
                id,
                isClearance,
                isFavorited,
                isHidden,
                label,
                meta,
                name,
                onDisplayInShowroomSlug,
                path,
                position,
                productFamily,
                productLabel,
                productType,
                quickship,
                secondaryImage,
                secondaryImageCropData,
                slug,
                variants,
                variantsToShow,
                variantsTotal,
                moreVariantsCount,
                bypass_stock,
                algoliaMetaData = {},
              },
              index
            ) => (
              <ProductCardStatic
                key={`advanced-search-product-${id}-${variantsToShow?.[0]
                  ?.sku ??
                  variants?.[0]?.sku ??
                  ''}`}
                campaign={campaign}
                enableMobileCarousel
                hidden={isHidden}
                id={id}
                isClearance={isClearance}
                isFavorited={isFavorited}
                label={label}
                layout="full"
                moreVariantsCount={
                  moreVariantsCount ??
                  variantsTotal - (variantsToShow?.length ?? 0)
                }
                name={name}
                onDisplayInShowroomSlug={onDisplayInShowroomSlug}
                path={path}
                position={position}
                productFamily={productFamily}
                productLabel={productLabel}
                productType={productType}
                quickship={quickship}
                secondaryImage={`${secondaryImage}`}
                secondaryImageCropData={secondaryImageCropData}
                slug={slug}
                variants={variants}
                variantsToShow={
                  variantsToShow?.map(variant => ({
                    ...variant,
                    image: `${variant?.image}`,
                  })) ??
                  variants
                    ?.slice(0, NUMBER_OF_SWATCHES_TO_SHOW)
                    .map(variant => ({
                      ...variant,
                      image: `${variant?.image}`,
                    })) ??
                  []
                }
                variantsTotal={variantsTotal}
                meta={meta}
                bypass_stock={bypass_stock}
                onClick={createSearchProductClickHandler(
                  algoliaMetaData,
                  setLastInsightsClick,
                  { index, productId: id }
                )}
              />
            )
          )}
      </ProductCardGridUI>
    </div>
  );
};

export default AdvancedSearchProductsGrid;
